export const lightTheme = {
  mode: "light",
  background: "#FFFFFF",
  text: "#111111",
  textSub: "#464646",
  textWhite: "#ffffff",
  textGray: "#797979",
  contactBtn: "#111111",
  headertext: "#383838",
  section: "#F5F5F5",
  headerbg: "#ffffff",
  herobg: "#ffffff",
  aboutbg: "#eeeeee",
  footerbg: "#b1b1b1",
  scrollBar: "#919191",
  scrollBg: "#b1b1b1",
  togglebtn: "#c4c4c4",
  imgfilter: "none",
};

export const darkTheme = {
  mode: "dark",
  background: "#000000",
  text: "#E5E5E5",
  textSub: "#b3b3b3",
  textWhite: "#111111",
  textGray: "#111111",
  contactBtn: "#E5E5E5",
  headertext: "#a1a1a1",
  section: "#1C1C1E",
  headerbg: "#000000ff",
  herobg: "#000000",
  aboutbg: "#292929",
  footerbg: "#222",
  scrollBar: "#919191",
  scrollBg: "#b1b1b1",
  togglebtn: "#727272",
  imgfilter: "brightness(0.7) contrast(1.1)",
};
